<era-attributes-ui [data]="attributes()"
                   (save)="save($event)"></era-attributes-ui>